import { render, staticRenderFns } from "./generateStatement.vue?vue&type=template&id=6cc9fde5&"
import script from "./generateStatement.vue?vue&type=script&lang=js&"
export * from "./generateStatement.vue?vue&type=script&lang=js&"
import style0 from "./generateStatement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cc9fde5')) {
      api.createRecord('6cc9fde5', component.options)
    } else {
      api.reload('6cc9fde5', component.options)
    }
    module.hot.accept("./generateStatement.vue?vue&type=template&id=6cc9fde5&", function () {
      api.rerender('6cc9fde5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchase/components/generateStatement.vue"
export default component.exports